/**
 * My API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PageableObject } from './pageableObject';
import { ReportResponseDTO } from './reportResponseDTO';
import { SortObject } from './sortObject';


export interface PageReportResponseDTO { 
    totalPages?: number;
    totalElements?: number;
    size?: number;
    content?: Array<ReportResponseDTO>;
    number?: number;
    sort?: SortObject;
    pageable?: PageableObject;
    numberOfElements?: number;
    first?: boolean;
    last?: boolean;
    empty?: boolean;
}

